var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99965 14.9999C8.13226 14.9999 8.25944 14.9472 8.35321 14.8535C8.44698 14.7597 8.49965 14.6325 8.49965 14.4999V2.70692L11.6457 5.85392C11.7395 5.9478 11.8669 6.00055 11.9997 6.00055C12.1324 6.00055 12.2598 5.9478 12.3537 5.85392C12.4475 5.76003 12.5003 5.63269 12.5003 5.49992C12.5003 5.36714 12.4475 5.2398 12.3537 5.14592L8.35365 1.14592C8.30721 1.09935 8.25203 1.06241 8.19129 1.0372C8.13054 1.012 8.06542 0.999023 7.99965 0.999023C7.93389 0.999023 7.86877 1.012 7.80802 1.0372C7.74728 1.06241 7.6921 1.09935 7.64565 1.14592L3.64565 5.14592C3.59917 5.1924 3.56229 5.24759 3.53713 5.30833C3.51197 5.36907 3.49902 5.43417 3.49902 5.49992C3.49902 5.63269 3.55177 5.76003 3.64565 5.85392C3.73954 5.9478 3.86688 6.00055 3.99966 6.00055C4.13243 6.00055 4.25977 5.9478 4.35366 5.85392L7.49965 2.70692V14.4999C7.49965 14.6325 7.55233 14.7597 7.6461 14.8535C7.73987 14.9472 7.86705 14.9999 7.99965 14.9999Z",
    fill: "#22C453"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressUp);
export default __webpack_public_path__ + "static/media/ProgressUp.75e0edd8e8f8c98aa5cb395f66101904.svg";
export { ForwardRef as ReactComponent };